import axios from "axios";
// import store from "../store/store";

const axiosSettings = () =>
  axios.create({
    baseURL: process.env.REACT_APP_BACKEND_API || "",
    headers: {
      "Content-Type": "application/json",
      "secret-key": process.env.REACT_APP_BACKEND_SECRET_KEY || "",
    },
  });

const axiosOracleSettings = () =>
  axios.create({
    baseURL: process.env.REACT_APP_ORACLE_BACKEND_API || "",
    headers: {
      "Content-Type": "application/json",
      // authorization: `Bearer ${store.getState().homePage.token}`,
    },
  });

export const getOracleMethod = async (url: string) => {
  const response = await axiosOracleSettings().get(url);
  return response;
};

export const getMethod = async (url: string) => {
  const response = await axiosSettings().get(url);
  return response;
};

export const postMethod = async (url: string, object: unknown) => {
  const response = await axiosSettings().post(url, object);
  return response.data;
};

export const deleteMethod = async (url: string) => {
  const response = await axiosSettings().delete(url);
  return response.data;
};

export const putMethod = async (url: string, object: unknown) => {
  const response = await axiosSettings().put(url, object);
  return response.data;
};
